import React from 'react';
import { FormattedMessage } from 'react-intl';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import moment from 'moment-timezone';
import { getInvoiceDetails } from '../../reducers/invoices';
import messages from '../../text/messages';
import { getDocumentDetails } from '../../reducers/documents';
import { getViceVersaFullName, formatMoney } from '../../utilities/string';
import { dateToFloatingString } from '../../utilities/dateTime';
import UserGroup from './userGroup';
import './invoice.css';
import { sortByName } from '../../utilities/sortUser';

class InvoicePage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            invoice: null
        };

        this.getInvoiceItems = this.getInvoiceItems.bind(this);
    }

    componentDidMount() {
        const { match, getInvoiceDetails } = this.props;
        getInvoiceDetails(match.params.invoiceId, invoice => this.setState({ invoice }));
    }

    getInvoiceItems() {
        const { items } = this.state.invoice;
        return Object.values(
            items.reduce((accumulator, current) => {
                const name = getViceVersaFullName(current);
                const description = current.description || `Period ending ${moment(current.period_ending).format('YYYY-MM-DD')}`;
                if (!accumulator[name]) {
                    accumulator[name] = [];
                }
                accumulator[name].push({ ...current, name, description });
                return accumulator;
            }, {})
        );
    }

    render() {
        const { invoice } = this.state;

        if (!invoice) {
            return null;
        }

        const { name, date, total, currency, client_name } = invoice;
        let workers = this.getInvoiceItems();
        const workerFirstItem = worker => (worker.length ? worker[0] : { last_name: ' ', first_name: ' ' });
        workers.sort((a, b) => sortByName(workerFirstItem(a), workerFirstItem(b)));

        return (
            <div className="page">
                <div className="row">
                    <div className="col-xs-12 col-sm-4 col-md-3">
                        <h4 className="bold">
                            <FormattedMessage {...messages.invoice} />: {name}
                        </h4>
                    </div>
                    <div className="col-xs-12 col-sm-8  col-md-9">
                        <h4 className="bold">
                            <FormattedMessage {...messages.client} />: {client_name}
                        </h4>
                    </div>
                </div>
                <hr />

                <div className="row">
                    <div className="col-sm-3 col-xs-6">
                        <div className="invoiceValues">{formatMoney(total, currency)}</div>
                        <div className="invoiceLabels">
                            <FormattedMessage {...messages.total} />
                        </div>
                    </div>
                    <div className="col-sm-2 col-xs-6">
                        <div className="invoiceValues"> {currency} </div>
                        <div className="invoiceLabels">
                            <FormattedMessage {...messages.currency} />
                        </div>
                    </div>
                    <div className="col-lg-2 col-md-3 col-sm-4  col-xs-6">
                        <div className="invoiceValues"> {dateToFloatingString(date, 'YYYY-MM-DD')}</div>
                        <div className="invoiceLabels">
                            <FormattedMessage {...messages.invoiceDate} />
                        </div>
                    </div>
                    <div className="col-sm-2 col-xs-6">
                        <div className="invoiceValues"> {workers.length}</div>
                        <div className="invoiceLabels">
                            <FormattedMessage {...messages.workers} />
                        </div>
                    </div>
                </div>
                <hr />

                <div className="row topOffset15">
                    <div className="col-sm-10 col-xs-12  topOffset15">{workers.map((item, i) => <UserGroup items={item} currency={currency} key={i} />)}</div>
                </div>

                <div className="row">
                    <div className="col-sm-10 col-xs-12">
                        <hr />
                        <hr />
                        <div className="invoiceTotal">
                            <FormattedMessage {...messages.total} /> <h4> {formatMoney(total, currency)} </h4>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

InvoicePage.meta = {
    hide: true,
    locations: ['/invoice/']
};

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            getInvoiceDetails,
            getDocumentDetails
        },
        dispatch
    );

export default connect(null, mapDispatchToProps)(InvoicePage);



// WEBPACK FOOTER //
// ./src/pages/invoice/index.jsx